// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { ExternalProviderLinkModel } from "@insite/client-framework/Services/IdentityService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import loadExternalProviders from "@insite/client-framework/Store/Pages/SignIn/Handlers/LoadExternalProviders";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

/* Valtech Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import FormActions, { FormActionsProps } from "@store/Library/Components/Toolkit/FormActions";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Valtech Custom Code - End */

const enum fields {
    fullWidthButton = "fullWidthButton",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.fullWidthButton]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    externalProviders: state.pages.signIn.externalProviders,
    signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
    location: getLocation(state),
});

const mapDispatchToProps = {
    loadExternalProviders,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface SignInExternalProvidersStyles {
    divider?: InjectableCss;
    titleText?: TypographyPresentationProps;
    providerButton?: ButtonPresentationProps;
    // Valtech Custom Code
    wrapper?: InjectableCss;
    formActions?: FormActionsProps;
}

export const signInExternalProvidersStyles: SignInExternalProvidersStyles = {
    wrapper: {
        css: spacingStyles("1em", null),
    },
    titleText: {
        variant: "p",
        forwardAs: "h3",
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    formActions: {
        spacing: "1em",
    },
    providerButton: { variant: "tertiary" },
};

const styles = signInExternalProvidersStyles;

const SignInExternalProviders = ({ externalProviders, loadExternalProviders, signInUrl, location, fields }: Props) => {
    useEffect(() => {
        if (!externalProviders) {
            loadExternalProviders();
        }
    }, [externalProviders]);

    const providerButtonClickHandler = (externalProvider: ExternalProviderLinkModel) => {
        if (!externalProvider.url) {
            return;
        }

        let returnUrl = "/";
        if (signInUrl && location.pathname.toLowerCase() === signInUrl?.toLowerCase()) {
            returnUrl = parseQueryString<{ returnUrl?: string }>(location.search).returnUrl || "/";
        } else {
            returnUrl = `${location.pathname}${location.search}`;
        }

        returnUrl = `${returnUrl + (returnUrl.indexOf("?") > -1 ? "&" : "?")}forcereturnurl`;
        returnUrl = encodeURIComponent(returnUrl);

        window.location.href = externalProvider.url.replace("returnurl%3a%2f", `returnurl%3a${returnUrl}`);
    };

    if (!externalProviders || externalProviders.length === 0) {
        return null;
    }

    // Valtech Removed - providerButtonCss

    return (
        <StyledWrapper {...styles.wrapper} /* Valtech Custom Code */>
            <Typography {...styles.titleText} /* Valtech Removed - "as" */>
                {translate("Use another service to log in.")}
            </Typography>
            <FormActions {...styles.formActions} fullWidth={fields.fullWidthButton} /* Valtech Custom Code */>
                {externalProviders.map(externalProvider => (
                    <Button
                        {...styles.providerButton}
                        // Valtech Removed - providerButtonCss
                        key={externalProvider.caption}
                        onClick={() => providerButtonClickHandler(externalProvider)}
                    >
                        {externalProvider.caption}
                    </Button>
                ))}
            </FormActions>
        </StyledWrapper>
    );
};

const Divider = styled.hr`
    ${styles.divider?.css}
`;

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SignInExternalProviders),
    definition: {
        allowedContexts: ["SignInPage", "SignInOverlay"],
        group: "Sign In",
        displayName: "External Providers",
        fieldDefinitions: [
            {
                name: fields.fullWidthButton,
                displayName: "Full Width Button",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 0,
            },
        ],
    },
};

export default widgetModule;
